/* import __COLOCATED_TEMPLATE__ from './fly-color-swatch.hbs.js'; */
import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';
export default class FlyColorSwatch extends Component {
  get style() {
    return this.args.color != null ? htmlSafe(`background-color: ${this.args.color};`) : undefined;
  }
}